import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userScreenerClientMenuRegistry = {
    personalize_userScreenerClient: {
        label: "User Screener Client",
        link: PAGE_URL.USER_SCREENER_CLIENT_PAGE,
        key: PAGE_URL.USER_SCREENER_CLIENT_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userScreenerClientMenuRegistry;
